import React, { FC, useState } from 'react';
import {
  Button,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text
} from '@chakra-ui/react';
import { Stake } from '@app/screens/nft-marketplace/NFTMarketplaceStakeDialog/components/Stake';
import { Unstake } from '@app/screens/nft-marketplace/NFTMarketplaceStakeDialog/components/Unstake';
import { Convert } from '@app/components/Convert';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const NftMarketplaceStakeDialog: FC<Props> = ({ isOpen, onClose }) => {
  const [view, setView] = useState<string>('stake');

  function renderViewButton(label: string, _view: string) {
    const isActive = _view === view;

    return (
      <Button
        variant="tertiary"
        onClick={() => setView(_view)}
        sx={{
          color: isActive ? 'orange' : 'gray.4',
          bg: isActive ? 'gray.2' : 'transparent',
          textTransform: 'capitalize'
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      motionPreset="slideInBottom"
      size="xs"
    >
      <ModalOverlay />
      <ModalContent
        sx={{
          maxWidth: ['100vw', '586px'],
          padding: '24px',
          backgroundColor: 'neutral.800'
        }}
      >
        <HStack alignItems="center" justifyContent="space-between" mb={3}>
          <Text textTransform="capitalize" color="white" fontWeight={500}>
            {view}
          </Text>
          <ModalCloseButton />
        </HStack>
        <HStack
          width="100%"
          sx={{
            borderRadius: '12px',
            border: '1px solid',
            borderColor: 'gray.5',
            padding: '8px 10px',
            backgroundColor: 'black'
          }}
        >
          {renderViewButton('Stake', 'stake')}
          {renderViewButton('Unstake', 'unstake')}
          {renderViewButton('Convert', 'convert')}
        </HStack>
        {view === 'stake' && <Stake />}
        {view === 'unstake' && <Unstake />}
        {view === 'convert' && <Convert />}
      </ModalContent>
    </Modal>
  );
};
